import { defineComponent as C, ref as x, computed as p, createElementBlock as s, openBlock as i, normalizeStyle as $, createBlock as k, createCommentVNode as b, withDirectives as I, normalizeClass as h, withCtx as B, createTextVNode as T, Fragment as V, renderList as W, createVNode as v, toDisplayString as z, unref as d, vShow as D } from "vue";
import "./CommentTileCore.vue_vue_type_style_index_0_scoped_db29f5cd_lang-BGz-jqNx.js";
import { t as L } from "./tooltip-YeSRTnG0.js";
/* empty css                                                                      */
import { u as M } from "./useClipboard-Bx1Cx7XB.js";
/* empty css                                                                        */
/* empty css                                                                      */
import "./idb-35dVPy4g.js";
import "./SvgRender.js";
import "./icon-C5cGsR9k.js";
/* empty css                                                                  */
import { _ as N } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import "./OverflowTooltip.js";
import { _ as O } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
/* empty css                                                                    */
import "./Chip.js";
/* empty css                                                                  */
import "./main-Bh5cSLmY.js";
/* empty css                                                          */
import "./debounce-BJrVv5jG.js";
/* empty css                                                                     */
/* empty css                                                                    */
import "./SearchInput.js";
import "./LoadMoreWrapper.js";
import "./Select-Dbr2pXH_.js";
/* empty css                                                                         */
/* empty css                                                                            */
import "./StatusSelect.js";
/* empty css                                                                      */
/* empty css                                                                */
import "./Reaction.vue_vue_type_style_index_0_scoped_a67a1bb4_lang-WDRHCN3u.js";
/* empty css                                                                     */
/* empty css                                                                           */
/* empty css                                                                        */
/* empty css                                                               */
/* empty css                                                                */
/* empty css                                                                          */
/* empty css                                                                      */
/* empty css                                                                        */
/* empty css                                                                */
/* empty css                                                                        */
/* empty css                                                                     */
/* empty css                                                        */
/* empty css                                                                        */
/* empty css                                                                            */
/* empty css                                                                            */
/* empty css                                                                     */
/* empty css                                                                      */
/* empty css                                                                            */
import "./MainCalendar.js";
import "./CalendarNavigationControl.js";
/* empty css                                                                       */
/* empty css                                                                          */
import S from "./TessHyperLink.js";
/* empty css                                                                   */
/* empty css                                                  */
import "./js.cookie-CA0diDCW.js";
import "./fileManager-BNE_Afa-.js";
import "pinia";
/* empty css                                                                        */
/* empty css                                                                  */
import "./CommentUploadFile.ce.vue_vue_type_script_lang-Bi4IeKWp.js";
import { _ as H } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const j = {
  key: 0,
  class: "tess-breadcrumb__separator"
}, A = /* @__PURE__ */ C({
  __name: "TessBreadcrumb",
  props: {
    url: {},
    items: {},
    lastItemWidth: { default: 150 },
    separator: { default: ">" },
    numberOfVisibleItems: { default: 4 },
    disabled: { type: Boolean, default: !1 },
    replaceCurrent: { type: Boolean, default: !1 },
    width: { default: 400 },
    canCopy: { type: Boolean, default: !0 }
  },
  setup(c) {
    const y = L, t = c, n = x(!1), { copyToClipboard: g, copyTooltip: w } = M(), u = p(() => t.width === "auto" ? "auto" : typeof t.width == "number" ? `${t.width}px` : t.width), f = p(() => Math.abs(t.numberOfVisibleItems || t.items.length)), o = p(() => t.items.slice(-f.value)), m = p(() => {
      const a = t.items.slice(0, t.items.length - f.value);
      return {
        items: a,
        count: a.length,
        tooltip: a.map((e) => e.name).join(" > ")
      };
    }), _ = () => {
      g(t.url);
    };
    return (a, e) => (i(), s("div", {
      class: "tess-breadcrumb",
      style: $({
        "--breadcrumb-width": `${u.value}`,
        "--number-of-items": o.value.length,
        "--max-width": `${u.value}`,
        "--last-item-width": `${t.lastItemWidth}px`,
        "--item-width": `calc(((${t.width ? u.value : "100%"} - ${t.lastItemWidth}px - ${m.value.count > 0 ? "20px" : "0px"} - ${!t.disabled && t.canCopy ? "32px" : "0px"} ) / ${o.value.length - 1}))`
      }),
      onMouseover: e[0] || (e[0] = (r) => n.value = !0),
      onMouseleave: e[1] || (e[1] = (r) => n.value = !1)
    }, [
      m.value.count > 0 ? (i(), k(N, {
        key: 0,
        content: m.value.tooltip,
        delay: [1e3, 0],
        class: h(["shorter-breadcrumb", {
          "has-tooltip": m.value.count > 0
        }])
      }, {
        default: B(() => [...e[2] || (e[2] = [
          T(".... ", -1)
        ])]),
        _: 1
      }, 8, ["content", "class"])) : b("", !0),
      (i(!0), s(V, null, W(o.value, (r, l) => (i(), s("div", {
        key: l,
        class: h(["tess-breadcrumb__item", { "last-item": l === o.value.length - 1, disabled: r.disabled }]),
        style: {}
      }, [
        v(S, {
          text: r.name,
          url: r.url,
          disabled: t.disabled || r.disabled,
          "replace-current": t.replaceCurrent,
          weight: l == o.value.length - 1 || r.isHighlight ? "bold" : "regular"
        }, null, 8, ["text", "url", "disabled", "replace-current", "weight"]),
        l !== o.value.length - 1 ? (i(), s("span", j, z(c.separator || ">"), 1)) : b("", !0)
      ], 2))), 128)),
      I(v(d(O), {
        type: "tertiary",
        size: "small",
        label: "",
        "prefix-icon": "Link",
        onClick: _
      }, null, 512), [
        [D, n.value && !t.disabled && t.canCopy],
        [d(y), {
          content: d(w),
          delay: [300, 0],
          hideOnClick: !1
        }]
      ])
    ], 36));
  }
}), Ut = /* @__PURE__ */ H(A, [["__scopeId", "data-v-cac10193"]]);
export {
  Ut as default
};
